import React from 'react';
import news from '../Assets/news1.jpg';
import news1 from '../Assets/news2.jpg';
import tree from '../Assets/tree.svg';

import mountain from '../Assets/illustration-mountain.svg'
const newsData = [
  {
    id: 1,
    image: news,
    title: 'Exciting Events: From fun-filled celebrations to cultural festivals, we ensure every child experiences the joy of learning beyond the classroom',
    // description: 'Discover the top learning toys recommended by teachers to spark creativity, enhance learning, and ensure hours of engaging play for young children. Perfect for parents looking to make learning fun!',
    tags: ['Kids']
  },
  {
    id: 2,
    image: news1,
    title: 'Achievements: Celebrate the milestones and creative accomplishments of our little learners and educators.',
    // description: 'Teachers share their expert picks for educational toys that help develop critical thinking, motor skills, and creativity in kids. Check out the latest recommendations today!',
    tags: [ 'Education']
  },
  {
    id: 3,
    image: news,
    title: 'Field Trip Adventures: Follow our students as they explore the world beyond the classroom through enriching field trips and outdoor experiences',
    // description: 'Discover the top learning toys recommended by teachers to spark creativity, enhance learning, and ensure hours of engaging play for young children. Perfect for parents looking to make learning fun!',
    tags: ['Kids']
  },
];

const News = () => {
  return (
    <div className='bg-[#f4f1ea] -mt-16  '>
      <div className='pt-24'>
        <h1 className='text-5xl font-bold text-center text-gray-800'>News</h1>
      </div>

      <div className='flex flex-wrap justify-center items-center pt-10 px-5 gap-10'>
        {newsData.map((item) => (
          <div key={item.id} className='overflow-hidden transition-transform transform hover:scale-105 mb-10 w-[390px]'>
            <div className='relative'>
              <img src={item.image} alt={`News ${item.id}`} className='w-full h-64 object-cover rounded-lg' />
              <div className='absolute top-2 left-2 bg-[#167287] text-white text-xs navbar-link font-bold py-1 px-2 rounded'>
                {item.tags.join(', ')}
              </div>
            </div>
            <div className='p-5 navbar-link'>
              <h2 className='text-[#16bab1]xl font-semibold text-gray-800 mb-4 '>{item.title}</h2>
              
            </div>
          </div>
        ))}
        
      </div>
      <div className='flex justify-center '>
                      <a href="https://www.instagram.com/kalamkidskindergarten" className="text-[#2b3a42] text-[#16bab1]xl">
                      <button className="px-4 py-2 border  border-[#16bab1] sensei-text text-[#16bab1] rounded-md shadow-lg">
                Read More
              </button>  
                      </a>
        
     
      </div>
      <div className=' relative '>
        <img src={mountain} alt="mountain" className=' absolute  -bottom-4' />
        <img src={tree} alt="tree" className=' absolute right-0 h-44 -bottom-8' />

      </div>
      <div className='wave rotate-180 '></div>
    </div>
  );
};

export default News;
